module.exports = __webpack_public_path__ + "static/media/4.b9581782.jpg";